import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button } from '../../styled-components';
import { actions as axisOrderActions } from '../../actions/axisOrder';
import { localizeAxis as localize } from '../../util/localizeUtils';

const ButtonContainer = styled.div`
  margin: 0.5rem 0;
  text-align: right;
  > button {
    margin-left: .25rem;
  }
`;

class AttachedFileButton extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.files.length > 0 && nextProps.files.length === 0) {
      // reset file input for new order
      this.attachedFile.value = '';
    }
  }
  onAddFiles = () => {
    this.props.onAddFile([...this.attachedFile.files]);
  }
  render() {
    return (
      <ButtonContainer>
        <Button onClick={() => { this.attachedFile.click(); }}>{localize('addAttachmentButton')}</Button>
        <input ref={r => { this.attachedFile = r; }} type="file" style={{ display: 'none' }} multiple onChange={this.onAddFiles} />
      </ButtonContainer>
    );
  }
}

AttachedFileButton.propTypes = {
  files: PropTypes.arrayOf(PropTypes.object).isRequired,
  onAddFile: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  files: state.axisOrder.files
});

const mapDispatchToProps = {
  onAddFile: axisOrderActions.addFile
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachedFileButton);



// WEBPACK FOOTER //
// ./app/components/OrderForm/AttachedFileButton.js